import { Injectable } from '@angular/core';
import { BaseServiceFacade, GenericApiCall } from '../../../common/store/types';
import { Store } from '@ngrx/store';
import { AppState } from '../types';
import { SourceModel } from './types';
import { sourceActions } from './source.action';
import { sourceSelectors } from './source.selector';
import { ListItem } from '../typeahead/types';

@Injectable()
export class SourceService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getById: GenericApiCall<SourceModel, string> = this.genericApiCall(
    sourceActions.getById,
    sourceSelectors.getById,
    true,
  );

  getList: GenericApiCall<ListItem[], void> = this.genericApiCall(
    sourceActions.getList,
    sourceSelectors.getList,
    true,
  );

  add: GenericApiCall<SourceModel, SourceModel> = this.genericApiCall(
    sourceActions.add,
    sourceSelectors.add,
    true,
  );

  update: GenericApiCall<SourceModel, SourceModel> = this.genericApiCall(
    sourceActions.update,
    sourceSelectors.update,
    true,
  );
}
